import * as React from 'react';
export const keySvg = React.forwardRef(function keySvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.585 2.051a5.25 5.25 0 0 1 7.425 7.425 5.245 5.245 0 0 1-5.206 1.317l-1.689 1.689a.75.75 0 0 1-.53.219h-.31v.415l-.006.101a1 1 0 0 1-.995.899H4.86v.414l-.006.101a1 1 0 0 1-.994.899H1.282a.75.75 0 0 1-.75-.75v-2.414c0-.464.185-.91.513-1.238L5.193 6.98a5.243 5.243 0 0 1 1.392-4.928Zm6.364 1.06a3.75 3.75 0 0 0-6.205 3.85.75.75 0 0 1-.18.77l-4.459 4.458-.03.038a.25.25 0 0 0-.043.139v1.664H3.36v-.414a1 1 0 0 1 1-1h.414V12.2a1 1 0 0 1 1-1h.5l1.798-1.798a.75.75 0 0 1 .813-.164 3.751 3.751 0 0 0 4.064-6.127Zm-2.828.709a1 1 0 0 1 1.414 0l.707.707a1 1 0 1 1-1.414 1.414l-.707-.707a1 1 0 0 1 0-1.414Z',
    }),
  );
});
keySvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var key = {
  category: 'icon',
  colorable: true,
  name: 'key',
  svg: keySvg,
};
